import React from 'react';
import {
  shape,
  string,
  bool,
  number,
  arrayOf,
  func,
} from 'prop-types';
import classNames from 'classnames';
import {
  Button,
} from 'components/common';
import withUserAgent from 'containers/withUserAgent';
import ProductImage from 'components/product/ProductImage';
import CompareElementColumn from 'components/product/CompareElementColumn';
import { onCtaClick } from 'money101/TWUtils';

import 'components/product/ProductPane/Row.scss';

const Row = (props) => {
  const {
    image = {},
    ctaButton = {},
    comparables = [],
    imageRoute,
    rowIndex,
    imageDimensions,
    defaultCTALabel = '',
    onCtaLinkClick,
    list,
    userAgent,
    verticalEnum,
    imageOrientation,
    lazyLoadImg,
    name,
    showModal,
  } = props;
  const ctaButtonClassNames = classNames({ placeholder: !ctaButton || !ctaButton.show });

  // Check if compare elements contain long prefix
  const hasLongPrefix = (comparables || [])
    .filter(({ prefix }) => prefix && prefix.length > 2).length > 0;

  const productPageLink = imageRoute
    && `${imageRoute}?entry=image${list ? `&from=${list}` : ''}`;

  const openKGIModal = (el) => {
    if (name === '凱基銀行 個人信貸 超低利率專案') {
      showModal();
    } else {
      onCtaClick(ctaButton, onCtaLinkClick, el);
    }
  };

  return (
    <div className="row" data-selector-type="row">
      {!(userAgent.isMobile && !userAgent.isTablet) && (
        <div
          className={classNames('column-image-wrapper', 'column', {
            'image-portrait': imageOrientation === 'PORTRAIT',
          })}
          data-selector-type="row-image"
        >
          {image?.url && (
            <ProductImage
              className="column-image"
              src={image?.url}
              imageDimensions={imageDimensions}
              alt={name}
              orientation={imageOrientation}
              to={productPageLink}
              lazy={lazyLoadImg}
            />
          )}
        </div>
      )}
      <div className="column column-row" data-selector-type="row-content">
        {comparables && comparables.map((element, index) => (
          <CompareElementColumn
            {...element}
            key={element.id}
            tooltipId={element.title.key + index + rowIndex}
            hasLongPrefix={hasLongPrefix}
            // eslint-disable-next-line no-underscore-dangle
            isPremium={element && element.__typename === 'CompareElementPrice'}
            verticalEnum={verticalEnum}
            numberOfCompareElements={comparables.length}
            ctaButton={ctaButton}
            onCtaLinkClick={onCtaLinkClick}
          />
        ))
        }
      </div>
      {!(userAgent.isMobile && !userAgent.isTablet) && (
        <div
          className="column column-button"
          data-selector-type="row-cta"
        >
          <Button
            primary
            disabled={!ctaButton || !ctaButton.show}
            className={ctaButtonClassNames}
            onClick={openKGIModal}
          >
            {(ctaButton && ctaButton.label) || defaultCTALabel}
          </Button>
        </div>
      )}
    </div>
  );
};

Row.defaultProps = {
  imageRoute: null,
  defaultCTALabel: null,
  ctaButton: null,
  onCtaLinkClick: undefined,
  list: null,
  userAgent: {},
  verticalEnum: null,
  imageOrientation: undefined,
  lazyLoadImg: true,
  name: '',
  showModal: undefined,
};

Row.propTypes = {
  image: shape({
    url: string.isRequired,
    alt: string,
  }).isRequired,
  ctaButton: shape({
    show: bool.isRequired,
    label: string.isRequired,
    link: shape({
      url: string.isRequired,
    }),
  }),
  comparables: arrayOf(shape({
    displayValue: string.isRequired,
    title: shape({
      key: string,
      display: string,
    }),
    description: string,
    tooltip: string,
  })).isRequired,
  imageRoute: string,
  rowIndex: number.isRequired,
  imageDimensions: shape({}).isRequired,
  defaultCTALabel: string,
  onCtaLinkClick: func,
  list: string,
  userAgent: shape({}),
  verticalEnum: string,
  imageOrientation: string,
  lazyLoadImg: bool,
  name: string,
  showModal: func,
};

export default withUserAgent(Row);
